import { useCallback, useEffect } from 'react';
import useTask from '../../../../modules/tasks/hooks/use-task';
import imgSrc from '../../../../assets/t-101/inicjal.jpg';
import './style.scss';
import QuestionBox from '../../../question-box';

type Props = {
    onComplete?: () => void
}

const Task101: React.FC<Props> = ({ onComplete: completeCallback }) => {

    const onComplete = useCallback(() => {
        if (completeCallback) {
            completeCallback();
        }
    }, [completeCallback]);

    const { task } = useTask('t-101');

    useEffect(() => {
        onComplete();
    }, [onComplete])

    return <div className="task task-101">
        <h2>zadanie 1</h2>
        <h3>{task?.title}</h3>
        <p>
            Przemądrzałe pióro, niesforne stalówki, gumka-myszka i ołówek. Kojarzycie tych bohaterów? Zamieszkują oni piórnik Tosi w bajce pt.: "Plastusiowy pamiętnik". Czy wiecie, że kiedyś, zamiast długopisów, w szkole pisało się piórem i atramentem? A to wcale nie było łatwe! Były nawet specjalne lekcje kaligrafii, czyli sztuki estetycznego pisania. Dziś kaligrafia już nie jest tak popularna, ale jako hobby ma działanie relaksacyjne.
        </p>
        <p className="instruction">
            <strong>Zadanie:</strong> przerysujcie poniższy kształt przedstawiający inicjał. Spróbujcie zrobić to najwolniej jak się da i nie odrywając pisaka od kartki przez minimum 15 minut.
        </p>
        <img src={imgSrc} alt="inicjał" />
        <QuestionBox>
            <p>
                Ile czasu udało Wam się na to poświęcić? Jak się czuliście w trakcie rysowania?<br />
            </p>
            <p>
                Sprawdźcie, czy w Waszej bibliotece są jakieś książki, w których występują inicjały!
            </p>
        </QuestionBox>
    </div>
}

export default Task101;
